import { Directive, HostListener, Input, Optional } from '@angular/core';
import { PopoverRef } from './popover-ref';

/**
 * Button that will close the current popover.
 */
@Directive({
  selector: '[sgtPopoverClose]',
})
export class PopoverCloseDirective<T> {
  @Input('p1PopoverClose') popoverResult: T;

  constructor(@Optional() private readonly popoverRef: PopoverRef<T>) {}

  @HostListener('click') onClick(): void {
    if (!this.popoverRef) {
      console.error('p1PopoverClose is not supported within a template');

      return;
    }

    this.popoverRef.close(this.popoverResult);
  }
}
